const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  status: "",
  searchTerm: "",
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    changeStatus: (state, action) => {
      state.status = action.payload;
    },
    changeSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
  },
});

export default filtersSlice.reducer;
export const { changeSearchTerm, changeStatus } = filtersSlice.actions;
